// extracted by mini-css-extract-plugin
export default {"divider":"categoryFood_divider__qnwPs"};